export default "__VITE_ASSET__ab5e4b40__"